<template>
<div>
  <div @click="exp=!exp" style="cursor:pointer">
    <v-icon>
      {{exp?'keyboard_arrow_down':'keyboard_arrow_up'}}
    </v-icon>
    <span :class="label_class||''">{{label}}</span>
  </div>
  <div v-if="exp">
    <slot></slot>
  </div>
</div>
</template>
<script>
export default {
  props:['label','label_class','expanded'],
  data(){
    return { exp:false }
  },
  watch:{
    expanded() { this.exp = !!this.expanded }
  },
  created() { this.exp = !!this.expanded }
};
</script>

